import React from "react"
import { useTheme } from "@material-ui/core/styles"
import { useTranslation } from "react-i18next"
import config from "../../../../config"
import { useSelector } from "react-redux"

export default function LanaguageLevel({ resultData, ai = false, tabIndex }) {
    const {
        theme: { bgColors, colors },
    } = useTheme()
    const { t } = useTranslation()
    const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
    const isContrast = themeState !== config.THEMES_MODES.LIGHT
    const languageLevel = resultData.formulaLanguageLevel || -1
    const languageLevelToString =  config.languageLevelToString
    const textLanguageLevel = languageLevelToString.find(v => v.threshold < languageLevel)
    return (
        <div className="mb-2 d-flex flex-column align-items-center w-100" style={{ backgroundColor: bgColors.bgPrimary100, maxWidth: "115px", height: "100px", overflow: "hidden", padding: "2px 15px", marginLeft: ai ? "7px" : "15px", borderRadius: "10px", filter: "drop-shadow(0 0 3px rgba(0, 0, 0, 0.161))" }} title={t("accessibility_analysis_lang-level")} tabIndex={tabIndex}>
            <p className="font-weight-bold" style={{ color: isContrast ? colors.colorContrast : colors.colorPrimary700, fontSize: "0.75rem" }}>
                {t("ai_gen_lang_level")}
            </p>
                <h2 style={{ color: isContrast ? colors.colorContrast : textLanguageLevel ? textLanguageLevel.color : colors.colorPrimary700 }} >
                    {textLanguageLevel ? textLanguageLevel.level : ''}
                </h2>
           
        </div>
    )
}
